import cost from './cost'
import employee from './employee'
import lease from './lease'
import ticket from './ticket'
import apiImport from './import'
import user from './user'
import integration from './integration'
import ap from './ap'
import company from './company'
import floor from './floor'
import neighborhood from './neighborhood'
import workplaceGroup from './workplaceGroup'
import portfolio from './portfolio'
import space from './space'
import city from './city'
import settings from './settings'
import building from './building'
import auth from './auth'
import asset from './asset'
import department from './department'
import booking from './booking'
import projection from './projections'
import QRCode from './QRCode'
import admin from './admin'
import shareSpace from './space/shareSpace'
import meetingRoom from './meetingRoom/meetingRoom'

export * from './types'
export * from './user/types'
export * from './employee/types'
export * from './ticket/types'
export * from './settings/types'
export * from './cost/types'

export default {
  user,
  employee,
  lease,
  ticket,
  cost,
  import: apiImport,
  integration,
  ap,
  company,
  floor,
  neighborhood,
  portfolio,
  space,
  city,
  settings,
  building,
  auth,
  workplaceGroup,
  asset,
  department,
  booking,
  projection,
  QRCode,
  admin,
  shareSpace,
  meetingRoom,
}
